// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"840":"f8de8aad","4112":"a86f1855","7768":"8e1c0585","8060":"a86f1855"}[chunkId] + ".chunk.css";
};